
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#7CD1A3","fill-opacity":".5","d":"M12.424 9.131a3.03 3.03 0 00-3.03 3.03v1.137h27.272v-1.136a3.03 3.03 0 00-3.03-3.03H12.424zm24.242 7.197H9.393v7.955a3.03 3.03 0 003.03 3.03h21.213a3.03 3.03 0 003.03-3.03v-7.955z"}}),_c('path',{attrs:{"fill":"#7CD1A4","d":"M3.333 19.359a3.03 3.03 0 013.03-3.03h21.213a3.03 3.03 0 013.03 3.03V31.48a3.03 3.03 0 01-3.03 3.03H6.363a3.03 3.03 0 01-3.03-3.03V19.36z"}}),_c('path',{attrs:{"fill":"#fff","d":"M5.985 29.586c0-.628.509-1.136 1.136-1.136h3.788a1.136 1.136 0 110 2.272H7.121a1.136 1.136 0 01-1.136-1.136z"}})])
          )
        }
      }
    